/* ==========================================================================
   Z500-SIDEBAR.JS – arhi-MAG Collection Filter + Search + Sort Engine
   Reads product data from Shopify collection tags/metafields,
   filters and sorts the ENTIRE catalogue client-side with zero page reloads,
   and paginates display cleanly at 30 products per page.
   ========================================================================== */
(function () {
  "use strict";

  /* ── FILTER STATE ──────────────────────────────────────────────────────── */
  var STATE = {
    search:       "",
    sort:         "default",
    page:         1,
    perPage:      30,
    usableMin:    0,
    usableMax:    600,
    builtMin:     30,
    builtMax:     400,
    floors:       [],
    garage:       [],
    rooms:        [],
    styles:       [],
    roofType:     [],
  };

  /* ── TRANSLATIONS (pentru label-urile din pills active) ─────────────────── */
  var FLOORS_MAP = {
    "casa parter":            "Parter",
    "casa cu mansarda":       "Cu mansardă",
    "casa cu etaj":           "Cu etaj",
    "casa cu pod":            "Cu pod",
    "casa cu antresola":      "Cu supantă",
    "casa cu mezanin":        "Cu mezanin",
    "posibilitate mansardare": "Posibilitate mansardare",
    "casa cu subsol":         "Cu subsol"
  };
  var GARAGE_MAP = {
    "fara garaj":             "Fără garaj",
    "garaj 1 masina":         "1 mașină",
    "garaj dublu":            "2 mașini (Dublu)",
    "garaj 3 masini":         "3+ mașini"
  };
  var STYLES_MAP = {
    "stil modern":            "Modern",
    "stil traditional":       "Tradițional",
    "stil scandinav":         "Scandinav",
    "stil mediteranean":      "Mediteranean",
    "stil italian":           "Italian",
    "stil hambar":            "Hambar modern",
    "stil clasic":            "Clasic",
    "stil minimalist":        "Minimalist",
    "vila moderna":           "Vilă / Rezidență",
    "stil industrial":        "Industrial",
    "stil rustic":            "Rustic"
  };
  var ROOF_MAP = {
    "acoperis 2 ape":         "2 ape (Gable)",
    "acoperis multi panta":   "Multi-pantă (Multi-slope)",
    "acoperis 4 ape":         "4 ape (4-pitch)",
    "acoperis plat":          "Plat (Flat)",
    "acoperis pupitru":       "1 apă (Pupitru / Desktop)"
  };


  /* ── HOUSE NAMES (120 feminine names, deterministic hash) ──────────────── */
  var HOUSE_NAMES = [
    "Elena","Sofia","Maria","Ana","Ioana","Alexandra","Andreea","Cristina",
    "Diana","Gabriela","Laura","Mihaela","Nicoleta","Oana","Patricia",
    "Raluca","Simona","Teodora","Valentina","Alina","Beatrice","Carmen",
    "Daniela","Florenta","Georgiana","Helene","Irina","Julia","Karla",
    "Luminita","Monica","Natalia","Octavia","Petra","Roxana","Sabrina",
    "Tatiana","Ursula","Victoria","Xenia","Yvonne","Zoe","Adela","Bella",
    "Clara","Delia","Eva","Felicia","Gina","Hana","Iris","Jasmine",
    "Kira","Lena","Maya","Nina","Olga","Paula","Rosa","Sara","Tina",
    "Vera","Yara","Zara","Amelia","Bianca","Celia","Dora","Emma",
    "Fiona","Grace","Hazel","Isla","Jade","Kate","Lily","Mia",
    "Nora","Olive","Rena","Stella","Tara","Viola","Wendy","Zelda",
    "Ariana","Brenda","Camila","Dina","Estela","Flora","Gloria","Hera",
    "Ingrid","Jana","Katia","Lara","Mara","Nadia","Ofelia","Pia",
    "Renata","Silvia","Thea","Vanda","Xandra","Ylva","Zona","Agata",
    "Brigitte","Corina","Dorina","Elvira","Frida","Greta","Hilde",
    "Isadora","Joana","Kendra","Loredana","Mirela"
  ];

  /* NAME_MAP is built once in init() by sorting all titles alphabetically
     so that: (a) each house gets a unique name, (b) new houses added later
     always get a stable assignment (sorted position stays consistent). */
  var NAME_MAP = {};

  function buildNameMap(cards) {
    /* Collect pairs of [productId, title], deduplicate by title */
    var pairs = [];
    var seen = {};
    cards.forEach(function(card) {
      var t = (card.dataset.title || "").trim();
      var id = parseInt(card.dataset.productId || 0, 10);
      if (!t || seen[t] || t.toLowerCase().indexOf("avans rezervare") !== -1 || id === 16246197092677) return;
      seen[t] = true;
      pairs.push({ id: id, title: t });
    });
    /* Sort by Shopify product ID (ascending = creation order).
       Older products always keep their names even when new ones are added. */
    pairs.sort(function(a, b) { return a.id - b.id; });
    /* Assign names sequentially; wrap around if > 120 houses */
    pairs.forEach(function(p, i) {
      NAME_MAP[p.title] = HOUSE_NAMES[i % HOUSE_NAMES.length];
    });
  }

  function getHouseName(originalTitle) {
    var t = (originalTitle || "").trim();
    /* Fallback: if somehow not in map, use a simple hash */
    if (NAME_MAP[t]) return NAME_MAP[t];
    var h = 0;
    for (var i = 0; i < t.length; i++) { h = ((h << 5) + h) + t.charCodeAt(i); h = h & h; }
    return HOUSE_NAMES[Math.abs(h) % HOUSE_NAMES.length];
  }

  /* ── CURATION & POPULARITY SCORES (Z500 BADGES & VIZUALIZARI 3D) ─────── */
  var FEATURED_SCORES = {
    "proiect-casa-iulia":10000,
    "proiect-casa-georgiana":9990,
    "proiect-casa-petra":9980,
    "proiect-casa-ioana":9970,
    "proiect-casa-fatima":9960,
    "proiect-casa-gisela":9950,
    "proiect-casa-yvanna-4":9940,
    "proiect-casa-ligia":9930,
    "proiect-casa-beatrice":9920,
    "proiect-casa-leona":9910,
    "proiect-casa-gina":9900,
    "proiect-casa-larissa":9890,
    "proiect-casa-cynthia-4":9880,
    "proiect-casa-z531":10000,
    "proiect-casa-zx179":9990,
    "proiect-casa-z574":9980,
    "proiect-casa-zx201":9970,
    "proiect-casa-z386":9960,
    "proiect-casa-zx250":9950,
    "proiect-casa-z378-b":9940,
    "proiect-casa-zx177":9930,
    "proiect-casa-z534":9920,
    "proiect-casa-zx209":9910,
    "proiect-casa-zx157":9900,
    "proiect-casa-z375-d":9890,
    "proiect-casa-z69-gp":9880,
    "proiect-casa-z241-d":156,"proiect-casa-elena-2":156,"proiect-casa-z212-d":169,"proiect-casa-sofia-2":169,"proiect-casa-z376-35":140,"proiect-casa-maria-2":140,"proiect-casa-z381":146,"proiect-casa-ana":146,"proiect-casa-z483-gaz":148,"proiect-casa-alexandra-2":148,"proiect-casa-z42-d":177,"proiect-casa-andreea-2":177,"proiect-casa-zb47-duo-sw":110,"proiect-casa-cristina-3":110,"proiect-casa-zx214-+":156,"proiect-casa-diana":156,"proiect-casa-zx214":156,"proiect-casa-zx214--":156,"proiect-casa-z577":168,"proiect-casa-gabriela":168,"proiect-casa-z7-d-30-pc-brzechwa":73,"proiect-casa-laura-17":73,"proiect-casa-z583":130,"proiect-casa-mihaela":130,"proiect-casa-z509":248,"proiect-casa-nicoleta":248,"proiect-casa-z582-v2":135,"proiect-casa-oana-2":135,"proiect-casa-z584":151,"proiect-casa-patricia":151,"proiect-casa-z508":50,"proiect-casa-raluca":50,"proiect-casa-z376-d-35-brzechwa":65,"proiect-casa-maria-3":65,"proiect-casa-z533":194,"proiect-casa-simona":194,"proiect-casa-z381-a":96,"proiect-casa-ana-2":96,"proiect-casa-zx178":94,"proiect-casa-teodora":94,"proiect-casa-zs8":40,"proiect-casa-alina":40,"proiect-casa-z583-d":71,"proiect-casa-mihaela-2":71,"proiect-casa-z548":133,"proiect-casa-carmen":133,"proiect-casa-z510":95,"proiect-casa-daniela":95,"proiect-casa-zx186":93,"proiect-casa-florenta":93,"proiect-casa-z568":211,"proiect-casa-irina":211,"proiect-casa-z530":73,"proiect-casa-monica":73,"proiect-casa-z572":236,"proiect-casa-octavia":236,"proiect-casa-z532":50,"proiect-casa-roxana":50,"proiect-casa-z273-a":195,"proiect-casa-sabrina-2":195,"proiect-casa-z7-d-30":239,"proiect-casa-laura-7":239,"proiect-casa-z8":208,"proiect-casa-ursula":208,"proiect-casa-zx51":34,"proiect-casa-victoria":34,"proiect-casa-z78-d":62,"proiect-casa-zoe-2":62,"proiect-casa-z262-d":65,"proiect-casa-adela-2":65,"proiect-casa-z71-d-gl":37,"proiect-casa-clara-5":37,"proiect-casa-z12":197,"proiect-casa-eva":30,"proiect-casa-z389":122,"proiect-casa-felicia":122,"proiect-casa-z57-d":103,"proiect-casa-hana":73,"proiect-casa-zx157-d":85,"proiect-casa-gina-2":85,"proiect-casa-z451":135,"proiect-casa-iris":135,"proiect-casa-zu8":26,"proiect-casa-iasmina":26,"proiect-casa-z39":180,"proiect-casa-kira":180,"proiect-casa-z12-d":156,"proiect-casa-eva-2":156,"proiect-casa-z42":144,"proiect-casa-andreea":144,"proiect-casa-z544-d":114,"proiect-casa-lena":114,"proiect-casa-zb47":74,"proiect-casa-cristina":29,"proiect-casa-z71-d":127,"proiect-casa-clara-2":127,"proiect-casa-z523-d":150,"proiect-casa-maia":150,"proiect-casa-z561":122,"proiect-casa-nina":122,"proiect-casa-z559":86,"proiect-casa-olga":86,"proiect-casa-z562":104,"proiect-casa-paula":104,"proiect-casa-z524":70,"proiect-casa-roza":70,"proiect-casa-z60-40-p":166,"proiect-casa-sara-3":166,"proiect-casa-z549":71,"proiect-casa-tina":71,"proiect-casa-z483":62,"proiect-casa-alexandra":62,"proiect-casa-z508-gaz":35,"proiect-casa-raluca-3":35,"proiect-casa-z87-d":126,"proiect-casa-vera-2":126,"proiect-casa-z71-eg":27,"proiect-casa-clara-3":27,"proiect-casa-z71":168,"proiect-casa-clara":168,"proiect-casa-z255-a":104,"proiect-casa-iara-2":104,"proiect-casa-z253":73,"proiect-casa-zara":73,"proiect-casa-z78":140,"proiect-casa-zoe":140,"proiect-casa-z87":180,"proiect-casa-vera":180,"proiect-casa-z352":76,"proiect-casa-amelia":76,"proiect-casa-z355":80,"proiect-casa-bianca":80,"proiect-casa-z410-d":58,"proiect-casa-ivona-2":58,"proiect-casa-z64-d":78,"proiect-casa-celia-2":78,"proiect-casa-z216-d":79,"proiect-casa-dora-2":79,"proiect-casa-z256-d":105,"proiect-casa-ema-2":105,"proiect-casa-z264-d":124,"proiect-casa-fiona-2":124,"proiect-casa-z11":164,"proiect-casa-gratiela":164,"proiect-casa-z211-d":66,"proiect-casa-delia-2":66,"proiect-casa-z7-d-35":143,"proiect-casa-laura-8":143,"proiect-casa-z255-d-a":124,"proiect-casa-iara-3":124,"proiect-casa-z7-d-gp":31,"proiect-casa-laura-9":31,"proiect-casa-z136-d":63,"proiect-casa-ilinca-2":63,"proiect-casa-z136":139,"proiect-casa-ilinca":139,"proiect-casa-z139":111,"proiect-casa-catinca":111,"proiect-casa-z151":70,"proiect-casa-crina":70,"proiect-casa-z377":191,"proiect-casa-eliza":191,"proiect-casa-z15":106,"proiect-casa-flavia":106,"proiect-casa-z16":205,"proiect-casa-ilona":205,"proiect-casa-z211":68,"proiect-casa-delia":68,"proiect-casa-z212":124,"proiect-casa-sofia":124,"proiect-casa-z216":79,"proiect-casa-dora":29,"proiect-casa-z217":77,"proiect-casa-letitia":77,"proiect-casa-z252":118,"proiect-casa-madalina":118,"proiect-casa-z254":77,"proiect-casa-miruna":77,"proiect-casa-z255":92,"proiect-casa-iara":92,"proiect-casa-z256":120,"proiect-casa-ema":120,"proiect-casa-z259":69,"proiect-casa-mona":69,"proiect-casa-z261":58,"proiect-casa-nadia":58,"proiect-casa-z262":120,"proiect-casa-adela":120,"proiect-casa-z264":139,"proiect-casa-fiona":139,"proiect-casa-z452":49,"proiect-casa-ruxandra":49,"proiect-casa-zx207":54,"proiect-casa-sandra":54,"proiect-casa-z262-d-gl":35,"proiect-casa-adela-4":35,"proiect-casa-z32":104,"proiect-casa-stela":104,"proiect-casa-z7-d":200,"proiect-casa-laura-2":200,"proiect-casa-z7-gp":89,"proiect-casa-laura-4":89,"proiect-casa-z418":26,"proiect-casa-tania":26,"proiect-casa-z454-(i)-real-green":33,"proiect-casa-angelica":42,"proiect-casa-z454-i-real-green":33,"proiect-casa-tereza-7":33,"proiect-casa-z427":77,"proiect-casa-valeria":77,"proiect-casa-z428":88,"proiect-casa-viviana":88,"proiect-casa-z11-d-tz":66,"proiect-casa-gratiela-3":66,"proiect-casa-z11-plus-120":55,"proiect-casa-gratiela-4":55,"proiect-casa-z11-d":136,"proiect-casa-gratiela-2":136,"proiect-casa-z12-d-ztb":90,"proiect-casa-eva-8":90,"proiect-casa-z12-gp+-(fr-s2s)":50,"proiect-casa-z12-gp-fr-s2s":50,"proiect-casa-eva-14":50,"proiect-casa-z12-gp--fr-s2s":50,"proiect-casa-z494":110,"proiect-casa-anca":110,"proiect-casa-z521":173,"proiect-casa-bogdana":173,"proiect-casa-z451-d":78,"proiect-casa-iris-2":78,"proiect-casa-z15-v2":55,"proiect-casa-flavia-4":55,"proiect-casa-z541":59,"proiect-casa-camelia":59,"proiect-casa-z541-d-ri":58,"proiect-casa-camelia-3":58,"proiect-casa-z16-gp":83,"proiect-casa-ilona-3":83,"proiect-casa-z16-d":61,"proiect-casa-ilona-2":61,"proiect-casa-z32-2k-b":52,"proiect-casa-stela-3":52,"proiect-casa-z541-d":58,"proiect-casa-camelia-2":58,"proiect-casa-z39-v2":31,"proiect-casa-kira-3":31,"proiect-casa-z12-d-eneroo":47,"proiect-casa-eva-10":47,"proiect-casa-z71-d-eneroo":63,"proiect-casa-clara-6":63,"proiect-casa-z39-d-eneroo":65,"proiect-casa-kira-6":65,"proiect-casa-z216-d-eneroo":65,"proiect-casa-dora-6":65,"proiect-casa-z78-d-eneroo":65,"proiect-casa-zoe-4":65,"proiect-casa-z57-d-h-+":73,"proiect-casa-z57-d-h":73,"proiect-casa-hana-3":73,"proiect-casa-z57-d-h--":73,"proiect-casa-z71-gl":26,"proiect-casa-clara-4":26,"proiect-casa-z259-d":114,"proiect-casa-mona-2":114,"proiect-casa-z60-40":112,"proiect-casa-sara-2":112,"proiect-casa-z39-d---40-a":32,"proiect-casa-filippa":63,"proiect-casa-z39-d--40-a":32,"proiect-casa-z428-st":62,"proiect-casa-viviana-2":62,"proiect-casa-z72-gl":51,"proiect-casa-doina-3":51,"proiect-casa-z78-gl":27,"proiect-casa-zoe-3":27,"proiect-casa-z451-d-tb-p\u0142":52,"proiect-casa-z537":85,"proiect-casa-dorina":85,"proiect-casa-z7-d-30-brzechwa":65,"proiect-casa-laura-16":65,"proiect-casa-z7-35-+":101,"proiect-casa-laura":201,"proiect-casa-z7-35":204,"proiect-casa-z7-35--":101,"proiect-casa-z563":69,"proiect-casa-elisabeta":69,"proiect-casa-z7-d-brzechwa":64,"proiect-casa-laura-15":64,"proiect-casa-z389-b":47,"proiect-casa-felicia-2":47,"proiect-casa-z211-pc":46,"proiect-casa-delia-4":46,"proiect-casa-z7-d-pc":86,"proiect-casa-laura-10":86,"proiect-casa-z78-d-brzechwa":59,"proiect-casa-zoe-5":59,"proiect-casa-z455-30-d":35,"proiect-casa-daciana":35,"proiect-casa-z451-d-eneroo":62,"proiect-casa-iris-5":62,"proiect-casa-z12-d-brzechwa":44,"proiect-casa-eva-11":44,"proiect-casa-z7-d-ecodom":60,"proiect-casa-laura-13":60,"proiect-casa-z255-d-a-ecodom":65,"proiect-casa-iara-5":65,"proiect-casa-z582":34,"proiect-casa-oana":34,"proiect-casa-z7-optimus":145,"proiect-casa-laura-12":145,"proiect-casa-z539":34,"proiect-casa-lidia":34,"proiect-casa-z72-d":132,"proiect-casa-doina-2":132,"proiect-casa-z216-gl":36,"proiect-casa-dora-3":36,"proiect-casa-z220-v2":33,"proiect-casa-livia-2":33,"proiect-casa-z262-gl":49,"proiect-casa-adela-3":49,"proiect-casa-z60":175,"proiect-casa-sara":175,"proiect-casa-z64":180,"proiect-casa-celia":73,"proiect-casa-z72-gp":103,"proiect-casa-doina-4":103,"proiect-casa-z212-gl":65,"proiect-casa-sofia-3":65,"proiect-casa-z139-v2":70,"proiect-casa-catinca-2":70,"proiect-casa-z297":119,"proiect-casa-malvina":119,"proiect-casa-z7-gl":84,"proiect-casa-laura-3":84,"proiect-casa-zx105":137,"proiect-casa-manuela":137,"proiect-casa-z7":201,"proiect-casa-z72":171,"proiect-casa-doina":171,"proiect-casa-z177":74,"proiect-casa-marilena":74,"proiect-casa-z75":88,"proiect-casa-marina":88,"proiect-casa-z177-gl":31,"proiect-casa-marilena-3":31,"proiect-casa-z256-pc":35,"proiect-casa-ema-4":35,"proiect-casa-z308":90,"proiect-casa-melania":90,"proiect-casa-z39-d-gl":56,"proiect-casa-kira-4":56,"proiect-casa-z313":31,"proiect-casa-olimpia":31,"proiect-casa-z151-d":26,"proiect-casa-crina-2":26,"proiect-casa-zx57":85,"proiect-casa-daria":85,"proiect-casa-zx53":76,"proiect-casa-cosmina":76,"proiect-casa-z7-d-30-gp":145,"proiect-casa-laura-11":145,"proiect-casa-z32-d":89,"proiect-casa-stela-2":89,"proiect-casa-z39-d":28,"proiect-casa-kira-2":28,"proiect-casa-z1":205,"proiect-casa-rodica":205,"proiect-casa-z366":62,"proiect-casa-sanziana":62,"proiect-casa-z297-d":78,"proiect-casa-malvina-2":78,"proiect-casa-z177-d":65,"proiect-casa-marilena-2":65,"proiect-casa-z273-d":140,"proiect-casa-sabrina-3":140,"proiect-casa-z61-d":26,"proiect-casa-severina-2":26,"proiect-casa-zx105-d":64,"proiect-casa-manuela-3":64,"proiect-casa-z241-d-gp":27,"proiect-casa-elena-5":27,"proiect-casa-z101-d":62,"proiect-casa-simina-2":62,"proiect-casa-z265-d":65,"proiect-casa-smaranda-2":65,"proiect-casa-z210-d-v1":27,"proiect-casa-sorana-4":27,"proiect-casa-zx77":30,"proiect-casa-stefania-3":30,"proiect-casa-z316":36,"proiect-casa-tamara":36,"proiect-casa-z141":64,"proiect-casa-tiberia":64,"proiect-casa-z229-d":27,"proiect-casa-voichita-2":27,"proiect-casa-z216-d-+":29,"proiect-casa-z216-d--":29,"proiect-casa-z440":33,"proiect-casa-adriana":33,"proiect-casa-z210":77,"proiect-casa-sorana":77,"proiect-casa-z220":76,"proiect-casa-livia":76,"proiect-casa-z227":54,"proiect-casa-agatha":54,"proiect-casa-z229":80,"proiect-casa-voichita":80,"proiect-casa-z241":126,"proiect-casa-elena":60,"proiect-casa-z242":28,"proiect-casa-agnes":28,"proiect-casa-z258":141,"proiect-casa-alberta":141,"proiect-casa-z469":39,"proiect-casa-alice":39,"proiect-casa-z30":80,"proiect-casa-alma":80,"proiect-casa-z1-d-wl":165,"proiect-casa-rodica-7":165,"proiect-casa-z1-d-bl":79,"proiect-casa-rodica-6":79,"proiect-casa-z1-d":90,"proiect-casa-rodica-2":90,"proiect-casa-z1-bl":88,"proiect-casa-rodica-3":88,"proiect-casa-z33":35,"proiect-casa-althea":35,"proiect-casa-z413":34,"proiect-casa-amanda":34,"proiect-casa-z34":117,"proiect-casa-anastasia":117,"proiect-casa-z478":63,"proiect-casa-angela":63,"proiect-casa-z4-d-(bbl)":71,"proiect-casa-z4-d-bbl":71,"proiect-casa-angelica-6":71,"proiect-casa-z4-d-bl":115,"proiect-casa-angelica-3":115,"proiect-casa-z512":95,"proiect-casa-astrid":95,"proiect-casa-z30-bl":34,"proiect-casa-alma-4":34,"proiect-casa-z4":105,"proiect-casa-z16-d-35":80,"proiect-casa-ilona-5":80,"proiect-casa-z16-35":65,"proiect-casa-ilona-4":65,"proiect-casa-z30-b":94,"proiect-casa-alma-2":94,"proiect-casa-z7-d-eneroo":144,"proiect-casa-laura-14":144,"proiect-casa-z211-d-eneroo":53,"proiect-casa-delia-6":53,"proiect-casa-z64-+":73,"proiect-casa-z64--":73,"proiect-casa-z241-d-(pf)":60,"proiect-casa-z241-d-pf":60,"proiect-casa-elena-8":60,"proiect-casa-z600":67,"proiect-casa-carina":67,"proiect-casa-z1-a-d":85,"proiect-casa-rodica-5":85,"proiect-casa-z578":109,"proiect-casa-casandra":109,"proiect-casa-z273-d-pc":85,"proiect-casa-sabrina-7":85,"proiect-casa-zb47-+":29,"proiect-casa-zb47--":29,"proiect-casa-z273-d-brzechwa":65,"proiect-casa-sabrina-8":65,"proiect-casa-z241-d-ecodom":65,"proiect-casa-elena-7":65,"proiect-casa-z273-sm":65,"proiect-casa-sabrina-4":65,"proiect-casa-z527":43,"proiect-casa-cecilia":43,"proiect-casa-z61":111,"proiect-casa-severina":111,"proiect-casa-z261-gp":51,"proiect-casa-nadia-2":51,"proiect-casa-z298":27,"proiect-casa-celestina":27,"proiect-casa-z261-gp-eg":45,"proiect-casa-nadia-3":45,"proiect-casa-z241-gp":30,"proiect-casa-elena-3":30,"proiect-casa-z241-gp2":30,"proiect-casa-elena-4":30,"proiect-casa-z4-d-bl-gp":76,"proiect-casa-angelica-5":76,"proiect-casa-z163":80,"proiect-casa-catalina-2":80,"proiect-casa-z174":77,"proiect-casa-chloe":77,"proiect-casa-z273":110,"proiect-casa-sabrina":110,"proiect-casa-z216-+":29,"proiect-casa-z216--":29,"proiect-casa-z329":74,"proiect-casa-adelina":74,"proiect-casa-z327":65,"proiect-casa-clarisa":65,"proiect-casa-z34-d":80,"proiect-casa-anastasia-2":80,"proiect-casa-z4-d":72,"proiect-casa-angelica-2":72,"proiect-casa-zx68-a-minus":25,"proiect-casa-cora":25,"proiect-casa-z112":32,"proiect-casa-cordelia":32,"proiect-casa-z114":116,"proiect-casa-cornelia":116,"proiect-casa-z102-d":80,"proiect-casa-cosette-2":80,"proiect-casa-z94-d":61,"proiect-casa-cristiana-2":61,"proiect-casa-z69-d":78,"proiect-casa-cynthia-2":78,"proiect-casa-z114-d":63,"proiect-casa-cornelia-2":63,"proiect-casa-z302-d":80,"proiect-casa-dalila-2":80,"proiect-casa-z102-d-gp":27,"proiect-casa-cosette-4":27,"proiect-casa-zx53-d":60,"proiect-casa-cosmina-2":60,"proiect-casa-z225-d":77,"proiect-casa-damiana-2":77,"proiect-casa-z332":33,"proiect-casa-daphne":33,"proiect-casa-z367":52,"proiect-casa-deborah":52,"proiect-casa-zx138":80,"proiect-casa-denise":80,"proiect-casa-z368":130,"proiect-casa-desiree":130,"proiect-casa-z334":79,"proiect-casa-dolores":79,"proiect-casa-zx137--":56,"proiect-casa-donatella-2":56,"proiect-casa-zx137":56,"proiect-casa-zx138-d":30,"proiect-casa-denise-2":30,"proiect-casa-z368-d":75,"proiect-casa-desiree-2":75,"proiect-casa-zx76-d":61,"proiect-casa-dania-2":61,"proiect-casa-z332-d":60,"proiect-casa-daphne-2":60,"proiect-casa-z369":76,"proiect-casa-electra":76,"proiect-casa-z369-d":80,"proiect-casa-electra-2":80,"proiect-casa-z372":78,"proiect-casa-eliana":78,"proiect-casa-z374":35,"proiect-casa-elise":35,"proiect-casa-z396":39,"proiect-casa-elodia":39,"proiect-casa-z377-b":86,"proiect-casa-eliza-2":86,"proiect-casa-z383":62,"proiect-casa-emilia":62,"proiect-casa-z384":189,"proiect-casa-emma":189,"proiect-casa-zx105-d-b":27,"proiect-casa-manuela-4":27,"proiect-casa-z177-d-+":35,"proiect-casa-letizia":25,"proiect-casa-z177-d--":35,"proiect-casa-zb26":57,"proiect-casa-eugenia":57,"proiect-casa-z225":77,"proiect-casa-damiana":77,"proiect-casa-z251":103,"proiect-casa-eulalia":103,"proiect-casa-z290":72,"proiect-casa-eunice":72,"proiect-casa-zx41":25,"proiect-casa-evelina":25,"proiect-casa-z38-d-gl":40,"proiect-casa-fabiola-2":40,"proiect-casa-zb7":62,"proiect-casa-fedora":62,"proiect-casa-z3":63,"proiect-casa-z470":59,"proiect-casa-flaviana":59,"proiect-casa-z465":105,"proiect-casa-flora":105,"proiect-casa-z1-gl":88,"proiect-casa-rodica-4":88,"proiect-casa-z473":162,"proiect-casa-florence":162,"proiect-casa-zx211":41,"proiect-casa-fortuna":41,"proiect-casa-z475":117,"proiect-casa-francesca":117,"proiect-casa-z3-d":87,"proiect-casa-filippa-2":87,"proiect-casa-z8-v2":42,"proiect-casa-ursula-5":42,"proiect-casa-z487":34,"proiect-casa-luminita":34,"proiect-casa-z429":65,"proiect-casa-frederica":65,"proiect-casa-z8-d":39,"proiect-casa-ursula-2":39,"proiect-casa-z38":74,"proiect-casa-fabiola":74,"proiect-casa-z12-wl":26,"proiect-casa-eva-5":26,"proiect-casa-z12-p":40,"proiect-casa-eva-3":40,"proiect-casa-z12-gl":77,"proiect-casa-eva-4":77,"proiect-casa-z30-d":44,"proiect-casa-alma-3":44,"proiect-casa-z34-d-gl":28,"proiect-casa-anastasia-3":28,"proiect-casa-z38-stu-gl":27,"proiect-casa-fabiola-5":27,"proiect-casa-z102-d-eneroo":65,"proiect-casa-cosette-5":65,"proiect-casa-z61-gl":70,"proiect-casa-severina-3":70,"proiect-casa-zx554":52,"proiect-casa-geanina":52,"proiect-casa-z69-gl-p":65,"proiect-casa-cynthia-5":65,"proiect-casa-zx554-d":53,"proiect-casa-geanina-2":53,"proiect-casa-zx63-v2":65,"proiect-casa-gilda-4":65,"proiect-casa-zx138-a-sd":57,"proiect-casa-denise-3":57,"proiect-casa-z255-d-a-40-sd":77,"proiect-casa-iara-4":77,"proiect-casa-z334-d":63,"proiect-casa-dolores-2":63,"proiect-casa-z38-d-v2":84,"proiect-casa-fabiola-4":84,"proiect-casa-z451-p":48,"proiect-casa-iris-3":48,"proiect-casa-z8-d-domikon":41,"proiect-casa-ursula-8":41,"proiect-casa-zx554-d-domikon":51,"proiect-casa-geanina-3":51,"proiect-casa-z507":35,"proiect-casa-giselle":35,"proiect-casa-z102-gp":27,"proiect-casa-cosette-3":27,"proiect-casa-z114-gl2":61,"proiect-casa-cornelia-3":61,"proiect-casa-z55":65,"proiect-casa-gloria":65,"proiect-casa-z191":74,"proiect-casa-erica":74,"proiect-casa-z296":79,"proiect-casa-greta":79,"proiect-casa-zx63":80,"proiect-casa-gilda":71,"proiect-casa-z233":30,"proiect-casa-guinevere":30,"proiect-casa-z265":78,"proiect-casa-smaranda":78,"proiect-casa-z69":80,"proiect-casa-cynthia":80,"proiect-casa-z101-v2":60,"proiect-casa-simina-5":60,"proiect-casa-z297-gf":26,"proiect-casa-malvina-3":26,"proiect-casa-z258-gp":47,"proiect-casa-alberta-3":47,"proiect-casa-z210-glt":29,"proiect-casa-sorana-3":29,"proiect-casa-z251-gl2":65,"proiect-casa-eulalia-2":65,"proiect-casa-z302":80,"proiect-casa-dalila":80,"proiect-casa-z177-+":31,"proiect-casa-z177--":31,"proiect-casa-zx63-a":71,"proiect-casa-gilda-2":71,"proiect-casa-z309":27,"proiect-casa-hannelore":27,"proiect-casa-zx63-b":71,"proiect-casa-gilda-6":71,"proiect-casa-zx65":63,"proiect-casa-heidi-2":63,"proiect-casa-zx117":76,"proiect-casa-helga":76,"proiect-casa-z93":80,"proiect-casa-giada":80,"proiect-casa-z94":80,"proiect-casa-cristiana":80,"proiect-casa-z99":80,"proiect-casa-hermione":80,"proiect-casa-z8-d-v2":38,"proiect-casa-ursula-6":38,"proiect-casa-z99-d":64,"proiect-casa-hermione-2":64,"proiect-casa-z101":80,"proiect-casa-simina":80,"proiect-casa-z340":103,"proiect-casa-hilda":103,"proiect-casa-z102":65,"proiect-casa-cosette":65,"proiect-casa-zx150":25,"proiect-casa-hortensia":25,"proiect-casa-z348":70,"proiect-casa-ilaria":70,"proiect-casa-z24-d":97,"proiect-casa-ingrid":97,"proiect-casa-z119-d":65,"proiect-casa-iolanda-2":65,"proiect-casa-z203-d":73,"proiect-casa-irene":73,"proiect-casa-z113":77,"proiect-casa-irma":77,"proiect-casa-z182-d":78,"proiect-casa-isabela":78,"proiect-casa-z113-d":69,"proiect-casa-irma-2":69,"proiect-casa-z292-d":95,"proiect-casa-isolde-2":95,"proiect-casa-z98-d":180,"proiect-casa-iustina-2":180,"proiect-casa-z131-d":63,"proiect-casa-jacqueline":63,"proiect-casa-z115":28,"proiect-casa-jolanda":28,"proiect-casa-z226-d":61,"proiect-casa-judith-2":61,"proiect-casa-z12-d-p-h+":55,"proiect-casa-z12-d-p-h":55,"proiect-casa-eva-9":55,"proiect-casa-z12-d-p-h-":55,"proiect-casa-z119":73,"proiect-casa-iolanda":73,"proiect-casa-z162-d":80,"proiect-casa-juliet":80,"proiect-casa-zx35-p-d":59,"proiect-casa-justine-3":59,"proiect-casa-z183-d":77,"proiect-casa-kassandra-2":77,"proiect-casa-z122":96,"proiect-casa-kiara":96,"proiect-casa-z95-a":77,"proiect-casa-leila":77,"proiect-casa-z376-d":80,"proiect-casa-maria":80,"proiect-casa-zx92":139,"proiect-casa-leonora":139,"proiect-casa-z13":27,"proiect-casa-liliana":27,"proiect-casa-z140":75,"proiect-casa-linda":75,"proiect-casa-z176":105,"proiect-casa-liuba":105,"proiect-casa-z344":26,"proiect-casa-lorelei":26,"proiect-casa-z328-d":30,"proiect-casa-luciana-2":30,"proiect-casa-z183":77,"proiect-casa-kassandra":77,"proiect-casa-z19":80,"proiect-casa-luna":80,"proiect-casa-z226":117,"proiect-casa-judith":117,"proiect-casa-z244":74,"proiect-casa-magda":74,"proiect-casa-zx17":54,"proiect-casa-marcela":54,"proiect-casa-zx201-d":126,"proiect-casa-ioana-2":126,"proiect-casa-zx35":71,"proiect-casa-justine":71,"proiect-casa-z485":75,"proiect-casa-margarita":75,"proiect-casa-z461":78,"proiect-casa-marianne":78,"proiect-casa-z468":35,"proiect-casa-marlene":35,"proiect-casa-z2-gl":48,"proiect-casa-mathilda-2":48,"proiect-casa-zx83":26,"proiect-casa-melissa":26,"proiect-casa-z472":134,"proiect-casa-mercedes":134,"proiect-casa-zx83-30":62,"proiect-casa-melissa-2":62,"proiect-casa-z431":39,"proiect-casa-mina":39,"proiect-casa-z499":47,"proiect-casa-mirela":47,"proiect-casa-z515":55,"proiect-casa-miriam":55,"proiect-casa-z12-p-h+":51,"proiect-casa-z12-p-h":51,"proiect-casa-eva-7":51,"proiect-casa-z12-p-h-":51,"proiect-casa-z14-w-bl":31,"proiect-casa-moira-4":31,"proiect-casa-z14-gp-p":96,"proiect-casa-moira-3":96,"proiect-casa-z40":160,"proiect-casa-nadine":160,"proiect-casa-z14-d-gp":56,"proiect-casa-moira-2":56,"proiect-casa-z41":74,"proiect-casa-naomi":74,"proiect-casa-z92-d-eneroo":65,"proiect-casa-neva-2":65,"proiect-casa-z581":71,"proiect-casa-nicole":71,"proiect-casa-z40-os":80,"proiect-casa-nadine-3":80,"proiect-casa-z454-p-gpt-(i)-real-green":51,"proiect-casa-z454-p-gpt-i-real-green":51,"proiect-casa-tereza-4":51,"proiect-casa-z98-d-brzechwa":65,"proiect-casa-iustina-4":65,"proiect-casa-z98-d-ecodom":105,"proiect-casa-iustina-3":105,"proiect-casa-z226-d-ecodom":62,"proiect-casa-judith-3":62,"proiect-casa-z504":112,"proiect-casa-norma":112,"proiect-casa-z499-gaz":47,"proiect-casa-mirela-2":47,"proiect-casa-z91-gl":47,"proiect-casa-odette-2":47,"proiect-casa-z162-glv2":59,"proiect-casa-juliet-2":59,"proiect-casa-z182-glp":25,"proiect-casa-isabela-2":25,"proiect-casa-zx35-gl2":66,"proiect-casa-justine-2":66,"proiect-casa-z293":80,"proiect-casa-ondina":80,"proiect-casa-z292":125,"proiect-casa-isolde":125,"proiect-casa-zx102":80,"proiect-casa-ophelia":80,"proiect-casa-zx102-gp":29,"proiect-casa-ophelia-2":29,"proiect-casa-z92":105,"proiect-casa-neva":105,"proiect-casa-z140-v1":28,"proiect-casa-linda-2":28,"proiect-casa-z287":74,"proiect-casa-paloma":74,"proiect-casa-z269":100,"proiect-casa-paola":100,"proiect-casa-z106-gl2":31,"proiect-casa-penelope-3":31,"proiect-casa-z219":141,"proiect-casa-phoebe":141,"proiect-casa-z113-eg":51,"proiect-casa-irma-3":51,"proiect-casa-zx116":43,"proiect-casa-tatiana":43,"proiect-casa-z328":80,"proiect-casa-luciana":80,"proiect-casa-z91":119,"proiect-casa-odette":119,"proiect-casa-z98":120,"proiect-casa-iustina":120,"proiect-casa-z14-d-w-bl":86,"proiect-casa-moira-5":86,"proiect-casa-z106-d":75,"proiect-casa-penelope-2":75,"proiect-casa-z2-d":35,"proiect-casa-mathilda":35,"proiect-casa-z106":74,"proiect-casa-penelope":74,"proiect-casa-z502":88,"proiect-casa-pia":88,"proiect-casa-z10":94,"proiect-casa-roberta":94,"proiect-casa-zx74":29,"proiect-casa-romina":29,"proiect-casa-z29--":36,"proiect-casa-rosalinda":53,"proiect-casa-z29":53,"proiect-casa-zx93":56,"proiect-casa-selena":56,"proiect-casa-z200-d":65,"proiect-casa-serena":65,"proiect-casa-z35-d":59,"proiect-casa-sibila":59,"proiect-casa-z209-d":61,"proiect-casa-siena":61,"proiect-casa-z207-d":60,"proiect-casa-silvana":60,"proiect-casa-zx54-d":59,"proiect-casa-simone":59,"proiect-casa-z240-d":77,"proiect-casa-solange":77,"proiect-casa-z10-d":139,"proiect-casa-roberta-2":139,"proiect-casa-z281-d":90,"proiect-casa-sonia":90,"proiect-casa-zx100-d":55,"proiect-casa-suzana":55,"proiect-casa-z124-d":64,"proiect-casa-sylvia":64,"proiect-casa-z196-d":58,"proiect-casa-teresa":58,"proiect-casa-z205-d":61,"proiect-casa-tiffany":61,"proiect-casa-z184-d":62,"proiect-casa-valery":62,"proiect-casa-z195-d":58,"proiect-casa-vanessa":58,"proiect-casa-z293-d":64,"proiect-casa-ondina-2":64,"proiect-casa-z79-d":77,"proiect-casa-veda":77,"proiect-casa-z52-d":56,"proiect-casa-vega":56,"proiect-casa-z120":32,"proiect-casa-velia":32,"proiect-casa-z123-d":58,"proiect-casa-venus":58,"proiect-casa-zx78":27,"proiect-casa-violeta":27,"proiect-casa-z333":75,"proiect-casa-vivien":75,"proiect-casa-z123":80,"proiect-casa-venus-2":80,"proiect-casa-z330-p":73,"proiect-casa-wanda":73,"proiect-casa-z124":80,"proiect-casa-sylvia-2":80,"proiect-casa-z379":105,"proiect-casa-ximena":105,"proiect-casa-z125":75,"proiect-casa-yasmin":75,"proiect-casa-zx141":75,"proiect-casa-yolanda":75,"proiect-casa-z378":197,"proiect-casa-yvanna":197,"proiect-casa-zb14":61,"proiect-casa-zea":61,"proiect-casa-zb25":70,"proiect-casa-zena":70,"proiect-casa-z126":64,"proiect-casa-zina":64,"proiect-casa-z394":35,"proiect-casa-zita":35,"proiect-casa-z127":32,"proiect-casa-amira":32,"proiect-casa-z349":131,"proiect-casa-anisa":131,"proiect-casa-z395":50,"proiect-casa-aria":50,"proiect-casa-z128":80,"proiect-casa-asia":80,"proiect-casa-zx190":27,"proiect-casa-avril":27,"proiect-casa-z129":33,"proiect-casa-azalea":33,"proiect-casa-z130":35,"proiect-casa-berenice":35,"proiect-casa-z148":51,"proiect-casa-candice":51,"proiect-casa-z8-b-40":40,"proiect-casa-ursula-9":40,"proiect-casa-z279":50,"proiect-casa-carmela-2":30,"proiect-casa-z282":90,"proiect-casa-cary":90,"proiect-casa-z166":28,"proiect-casa-celeste":28,"proiect-casa-z173":78,"proiect-casa-cielo":78,"proiect-casa-z378-d":113,"proiect-casa-yvanna-2":113,"proiect-casa-z379-d":26,"proiect-casa-ximena-2":26,"proiect-casa-z349-d":127,"proiect-casa-anisa-2":127,"proiect-casa-z321-d":65,"proiect-casa-clotilde":65,"proiect-casa-zx137-d":53,"proiect-casa-donatella-3":53,"proiect-casa-zx96-d":74,"proiect-casa-collette":74,"proiect-casa-zx63-d-b-+":45,"proiect-casa-zx63-d-b":45,"proiect-casa-gilda-5":45,"proiect-casa-zx63-d-b--":45,"proiect-casa-z441":78,"proiect-casa-delilah":78,"proiect-casa-z186":27,"proiect-casa-dina":27,"proiect-casa-z196":76,"proiect-casa-teresa-2":76,"proiect-casa-z200":80,"proiect-casa-serena-3":80,"proiect-casa-z202":77,"proiect-casa-dorothea":77,"proiect-casa-z203":72,"proiect-casa-irene-2":72,"proiect-casa-z205":73,"proiect-casa-tiffany-2":73,"proiect-casa-z207":78,"proiect-casa-silvana-2":78,"proiect-casa-z209":75,"proiect-casa-siena-2":75,"proiect-casa-z215":37,"proiect-casa-eleonora":37,"proiect-casa-z222":74,"proiect-casa-elisaveta":74,"proiect-casa-z235":49,"proiect-casa-esther":49,"proiect-casa-z237":27,"proiect-casa-eudoxia":27,"proiect-casa-z239":27,"proiect-casa-evangeline":27,"proiect-casa-z240":137,"proiect-casa-solange-2":137,"proiect-casa-z443":93,"proiect-casa-eveline":93,"proiect-casa-z23":105,"proiect-casa-federica":105,"proiect-casa-z263":76,"proiect-casa-filofteia":76,"proiect-casa-z294":72,"proiect-casa-fleur":72,"proiect-casa-z387":80,"proiect-casa-florina":80,"proiect-casa-z223-d":63,"proiect-casa-gabrielle":63,"proiect-casa-z388":162,"proiect-casa-gala":162,"proiect-casa-zx23":49,"proiect-casa-olivia-2":49,"proiect-casa-zx24":74,"proiect-casa-gianna":74,"proiect-casa-z446":65,"proiect-casa-gloriana":65,"proiect-casa-z86-a":30,"proiect-casa-gordana":30,"proiect-casa-z388-d":177,"proiect-casa-gala-2":177,"proiect-casa-z443-d":122,"proiect-casa-eveline-2":122,"proiect-casa-z445":46,"proiect-casa-gu":46,"proiect-casa-z445-d":49,"proiect-casa-gu-2":49,"proiect-casa-zx255":90,"proiect-casa-helena":90,"proiect-casa-zx34":58,"proiect-casa-honorata":58,"proiect-casa-zx44":78,"proiect-casa-ioanina":78,"proiect-casa-z449":80,"proiect-casa-isadora":80,"proiect-casa-z456":60,"proiect-casa-ivanka":60,"proiect-casa-z446-d":30,"proiect-casa-gloriana-2":30,"proiect-casa-zx49":103,"proiect-casa-jeanette":103,"proiect-casa-z459":155,"proiect-casa-jessie":155,"proiect-casa-z460":78,"proiect-casa-joanna":78,"proiect-casa-z459-d":50,"proiect-casa-jessie-2":50,"proiect-casa-zx161":52,"proiect-casa-josefina":52,"proiect-casa-zx50":76,"proiect-casa-judita":76,"proiect-casa-zx54":77,"proiect-casa-simone-2":77,"proiect-casa-zx60":76,"proiect-casa-kamila":76,"proiect-casa-zb4":116,"proiect-casa-karolina":116,"proiect-casa-zb5":76,"proiect-casa-katarina":76,"proiect-casa-z463":121,"proiect-casa-kerstin":121,"proiect-casa-z466":60,"proiect-casa-lara":60,"proiect-casa-zs1":99,"proiect-casa-lea":99,"proiect-casa-zb37":47,"proiect-casa-leticia":47,"proiect-casa-zx165":47,"proiect-casa-lilliana":47,"proiect-casa-zx166":92,"proiect-casa-lisbeth":92,"proiect-casa-zx87":75,"proiect-casa-lora-3":45,"proiect-casa-z408":94,"proiect-casa-loredana":94,"proiect-casa-zx167":26,"proiect-casa-loretta":26,"proiect-casa-zx86":80,"proiect-casa-lotti":80,"proiect-casa-zx149":63,"proiect-casa-louisa":63,"proiect-casa-zx260":25,"proiect-casa-lucile":25,"proiect-casa-z409":57,"proiect-casa-lucretia":57,"proiect-casa-z412":49,"proiect-casa-magdalena":49,"proiect-casa-z471":44,"proiect-casa-malia":44,"proiect-casa-zx168":80,"proiect-casa-marcie":80,"proiect-casa-z35":28,"proiect-casa-sibila-2":28,"proiect-casa-z36":44,"proiect-casa-margaux":44,"proiect-casa-z423":121,"proiect-casa-marusya":121,"proiect-casa-z426":86,"proiect-casa-melisa":86,"proiect-casa-z425":77,"proiect-casa-melody":77,"proiect-casa-zx31":80,"proiect-casa-milana":80,"proiect-casa-zx172":37,"proiect-casa-milena":37,"proiect-casa-z10-stu":30,"proiect-casa-roberta-3":30,"proiect-casa-z10-gl2-stu":63,"proiect-casa-roberta-4":63,"proiect-casa-zx176":36,"proiect-casa-muriel":36,"proiect-casa-z477":65,"proiect-casa-nailah":65,"proiect-casa-z511":40,"proiect-casa-nastia":40,"proiect-casa-zx215":41,"proiect-casa-natasa":41,"proiect-casa-z518":53,"proiect-casa-nikita":53,"proiect-casa-z525":55,"proiect-casa-ninon":55,"proiect-casa-zx220":39,"proiect-casa-oksana":39,"proiect-casa-z522":55,"proiect-casa-olena":55,"proiect-casa-zx217":40,"proiect-casa-ornella":40,"proiect-casa-z41-+":42,"proiect-casa-z41--":42,"proiect-casa-z47":50,"proiect-casa-palmyra":50,"proiect-casa-z402":80,"proiect-casa-noreen-3":80,"proiect-casa-z406":120,"proiect-casa-pelaghia":120,"proiect-casa-z317":58,"proiect-casa-perla":58,"proiect-casa-zx96":78,"proiect-casa-collette-2":78,"proiect-casa-z554":28,"proiect-casa-perrine":28,"proiect-casa-z378-30":88,"proiect-casa-yvanna-3":88,"proiect-casa-z66-gl-+":53,"proiect-casa-petrina-2":53,"proiect-casa-z66-gl":53,"proiect-casa-z66-gl--":53,"proiect-casa-z49":42,"proiect-casa-philomela":42,"proiect-casa-z66-d-zp":31,"proiect-casa-petrina-4":31,"proiect-casa-z372-v2":58,"proiect-casa-eliana-3":58,"proiect-casa-z321-d-35":60,"proiect-casa-clotilde-2":60,"proiect-casa-z466-a-35":79,"proiect-casa-lara-2":79,"proiect-casa-z412-30-sm":31,"proiect-casa-magdalena-2":31,"proiect-casa-zx204-b-30":59,"proiect-casa-polixenia":59,"proiect-casa-z295-+":33,"proiect-casa-prisca":33,"proiect-casa-z295":33,"proiect-casa-z295--":33,"proiect-casa-zx88-a":48,"proiect-casa-rada":48,"proiect-casa-z349-gp2":44,"proiect-casa-anisa-3":44,"proiect-casa-z5":41,"proiect-casa-radmila":41,"proiect-casa-zx87-b":33,"proiect-casa-lora-2":33,"proiect-casa-z349-b":57,"proiect-casa-anisa-4":57,"proiect-casa-z472-a":32,"proiect-casa-mercedes-2":32,"proiect-casa-z566":146,"proiect-casa-rafaela":146,"proiect-casa-zb25-d":31,"proiect-casa-zena-2":31,"proiect-casa-z565":124,"proiect-casa-rania":124,"proiect-casa-z577-d-brzechwa":46,"proiect-casa-gabriela-2":46,"proiect-casa-z459-d-ecodom":51,"proiect-casa-jessie-3":51,"proiect-casa-z330-p-pc":56,"proiect-casa-wanda-3":56,"proiect-casa-z503":47,"proiect-casa-roxani":47,"proiect-casa-z547":147,"proiect-casa-ruslana":147,"proiect-casa-z349-b-sm":56,"proiect-casa-anisa-5":56,"proiect-casa-z564":94,"proiect-casa-sallie":94,"proiect-casa-z113-gl":65,"proiect-casa-irma-4":65,"proiect-casa-z122-v2":88,"proiect-casa-kiara-2":88,"proiect-casa-z125-d":45,"proiect-casa-yasmin-2":45,"proiect-casa-z128-gp":28,"proiect-casa-asia-2":28,"proiect-casa-zx101-gp2":26,"proiect-casa-salomea":26,"proiect-casa-z195":76,"proiect-casa-vanessa-2":76,"proiect-casa-z278":26,"proiect-casa-sasha":26,"proiect-casa-z6":36,"proiect-casa-sebastiana":36,"proiect-casa-z285":29,"proiect-casa-selene":29,"proiect-casa-z195-gf":36,"proiect-casa-vanessa-3":36,"proiect-casa-z200-+100":56,"proiect-casa-luisa":99,"proiect-casa-z200-100":56,"proiect-casa-serena-4":56,"proiect-casa-z200--100":56,"proiect-casa-z283":120,"proiect-casa-seraphina":120,"proiect-casa-z284":75,"proiect-casa-severa":75,"proiect-casa-z204-l-v2":89,"proiect-casa-shira":89,"proiect-casa-z124-+-60":30,"proiect-casa-z124--60":30,"proiect-casa-z124---60":30,"proiect-casa-z52":68,"proiect-casa-vega-2":68,"proiect-casa-z54":38,"proiect-casa-silke":38,"proiect-casa-zx59":31,"proiect-casa-solene":31,"proiect-casa-z195-gf2":26,"proiect-casa-vanessa-4":26,"proiect-casa-zx103":75,"proiect-casa-stacy":75,"proiect-casa-z66":80,"proiect-casa-petrina-5":80,"proiect-casa-z89":59,"proiect-casa-stanislava":59,"proiect-casa-z184":80,"proiect-casa-valery-3":80,"proiect-casa-z281":80,"proiect-casa-sonia-2":80,"proiect-casa-zx106":80,"proiect-casa-svetlana":80,"proiect-casa-z96":64,"proiect-casa-sybil":64,"proiect-casa-z150":80,"proiect-casa-tabita":80,"proiect-casa-z223":80,"proiect-casa-gabrielle-2":80,"proiect-casa-z92-gl":32,"proiect-casa-neva-5":32,"proiect-casa-z204-bg":27,"proiect-casa-shira-3":27,"proiect-casa-z200-bg":80,"proiect-casa-serena-5":80,"proiect-casa-z304":65,"proiect-casa-therese":65,"proiect-casa-z305":28,"proiect-casa-tomiris":28,"proiect-casa-z79":105,"proiect-casa-veda-4":105,"proiect-casa-z310":29,"proiect-casa-ulrika":29,"proiect-casa-z7-p-35":79,"proiect-casa-laura-18":79,"proiect-casa-z80":26,"proiect-casa-wilma-3":26,"proiect-casa-z301":80,"proiect-casa-una":80,"proiect-casa-zx115":28,"proiect-casa-valerya":28,"proiect-casa-z281-stu":79,"proiect-casa-sonia-3":79,"proiect-casa-z318":31,"proiect-casa-vasilica":31,"proiect-casa-zx56":62,"proiect-casa-veridiana":62,"proiect-casa-zx121":30,"proiect-casa-vita":30,"proiect-casa-z38-plus":50,"proiect-casa-fabiola-6":50,"proiect-casa-zx40-2m":33,"proiect-casa-vittoria":33,"proiect-casa-zx63-b-+":71,"proiect-casa-zx63-b--":71,"proiect-casa-z67-a":80,"proiect-casa-cleopatra-2":80,"proiect-casa-zx185":59,"proiect-casa-yelena":59,"proiect-casa-z321":140,"proiect-casa-clotilde-3":140,"proiect-casa-z121-a":47,"proiect-casa-viola-2":47,"proiect-casa-zx67":57,"proiect-casa-zalina":57,"proiect-casa-z314":34,"proiect-casa-sabine-2":34,"proiect-casa-zx69":30,"proiect-casa-zenobia":30,"proiect-casa-z330":33,"proiect-casa-wanda-4":33,"proiect-casa-zx129":58,"proiect-casa-zhenya":58,"proiect-casa-z339":32,"proiect-casa-zlata":32,"proiect-casa-zx71":55,"proiect-casa-zora":55,"proiect-casa-z104":33,"proiect-casa-allegra":33,"proiect-casa-zx133":25,"proiect-casa-anabella":25,"proiect-casa-z357":134,"proiect-casa-araceli":134,"proiect-casa-z108":80,"proiect-casa-arianna":80,"proiect-casa-z346":30,"proiect-casa-arlette":30,"proiect-casa-z19-d":57,"proiect-casa-luna-2":57,"proiect-casa-z173-d":59,"proiect-casa-cielo-2":59,"proiect-casa-z199-d":80,"proiect-casa-belen":80,"proiect-casa-z158-d":61,"proiect-casa-belinda":61,"proiect-casa-z116":32,"proiect-casa-bella":32,"proiect-casa-z373":29,"proiect-casa-brunella":29,"proiect-casa-zx75":55,"proiect-casa-carlotta":55,"proiect-casa-zx107":76,"proiect-casa-carminda":76,"proiect-casa-zx79":28,"proiect-casa-caterina":28,"proiect-casa-zx139":80,"proiect-casa-consuelo":80,"proiect-casa-zx99":39,"proiect-casa-cristela-3":39,"proiect-casa-z315":27,"proiect-casa-dafne":27,"proiect-casa-zx126":51,"proiect-casa-eloisa":51,"proiect-casa-z316-p":51,"proiect-casa-tamara-3":51,"proiect-casa-zx151":60,"proiect-casa-enrica":60,"proiect-casa-z143":32,"proiect-casa-fiamma":32,"proiect-casa-z291":59,"proiect-casa-giuliana":59,"proiect-casa-z170":50,"proiect-casa-graziella":50,"proiect-casa-z357-d":92,"proiect-casa-araceli-2":92,"proiect-casa-z187":52,"proiect-casa-isotta":52,"proiect-casa-z17":25,"proiect-casa-z199":120,"proiect-casa-belen-2":120,"proiect-casa-z18":65,"proiect-casa-lucila":65,"proiect-casa-z20":99,"proiect-casa-z21":26,"proiect-casa-mafalda":26,"proiect-casa-z22":58,"proiect-casa-marella":58,"proiect-casa-z270":80,"proiect-casa-margherita":80,"proiect-casa-z275":25,"proiect-casa-mariangela":25,"proiect-casa-zr1":29,"proiect-casa-martina":29,"proiect-casa-zr5":124,"proiect-casa-matilde":124,"proiect-casa-zx1":49,"proiect-casa-michela":49,"proiect-casa-zx154":61,"proiect-casa-nicoletta":61,"proiect-casa-zx5":81,"proiect-casa-ottavia":81,"proiect-casa-zx7":27,"proiect-casa-patrizia":27,"proiect-casa-zx10":30,"proiect-casa-piera":30,"proiect-casa-zx12":76,"proiect-casa-raffaella":76,"proiect-casa-zx14":59,"proiect-casa-rachele":59,"proiect-casa-zx15":59,"proiect-casa-rosalba":59,"proiect-casa-zx158":140,"proiect-casa-rossella":140,"proiect-casa-z35-a-bg":87,"proiect-casa-sibila-3":87,"proiect-casa-z26":80,"proiect-casa-susanna":80,"proiect-casa-zx29":62,"proiect-casa-vanna":62,"proiect-casa-zx40":76,"proiect-casa-vittoria-2":76,"proiect-casa-zx46":29,"proiect-casa-aitana":29,"proiect-casa-zx251":60,"proiect-casa-amparo":60,"proiect-casa-zx159":64,"proiect-casa-antoaneta":64,"proiect-casa-zx48":87,"proiect-casa-beatriz":87,"proiect-casa-zx204":65,"proiect-casa-polixenia-2":65,"proiect-casa-zx55":126,"proiect-casa-begona":126,"proiect-casa-zx101":120,"proiect-casa-salomea-2":120,"proiect-casa-z2-a":41,"proiect-casa-mathilda-3":41,"proiect-casa-zm1":29,"proiect-casa-catalina":29,"proiect-casa-zx163":30,"proiect-casa-coralia":30,"proiect-casa-zx85":65,"proiect-casa-covadonga":65,"proiect-casa-z8-40-a-gp2":54,"proiect-casa-ursula-11":54,"proiect-casa-z10-stu-30":34,"proiect-casa-roberta-5":34,"proiect-casa-z10-d-sdu":48,"proiect-casa-roberta-6":48,"proiect-casa-zx218":35,"proiect-casa-rebeca":35,"proiect-casa-zb44":52,"proiect-casa-fatme":52,"proiect-casa-z46":33,"proiect-casa-gisella":33,"proiect-casa-z555":126,"proiect-casa-jimena":126,"proiect-casa-zx210":34,"proiect-casa-lourdes":34,"proiect-casa-zx180-p-gl2":74,"proiect-casa-priscilla":74,"proiect-casa-z388-d-a":73,"proiect-casa-gala-3":73,"proiect-casa-zb32-gl-duo":31,"proiect-casa-katia-3":31,"proiect-casa-zx87-+":45,"proiect-casa-zx87--":45,"proiect-casa-z388-b":108,"proiect-casa-gala-4":108,"proiect-casa-z446-b":32,"proiect-casa-gloriana-3":32,"proiect-casa-zx126-ba":51,"proiect-casa-eloisa-2":51,"proiect-casa-z279-+":30,"proiect-casa-z279--":30,"proiect-casa-zb55":25,"proiect-casa-maite":25,"proiect-casa-z579":170,"proiect-casa-maricarmen":170,"proiect-casa-z2-+-gl2":34,"proiect-casa-mathilda-4":34,"proiect-casa-z2--gl2":34,"proiect-casa-z2---gl2":34,"proiect-casa-z199-d-domikon":65,"proiect-casa-belen-3":65,"proiect-casa-z51":31,"proiect-casa-mercedesita":31,"proiect-casa-z533-bg":128,"proiect-casa-simona-2":128,"proiect-casa-zx39-gp2":64,"proiect-casa-milagros":64,"proiect-casa-z288":80,"proiect-casa-montserrat":80,"proiect-casa-z193":30,"proiect-casa-nieves":30,"proiect-casa-z159":27,"proiect-casa-nuria":27,"proiect-casa-zx114":75,"proiect-casa-palomita":75,"proiect-casa-z268":25,"proiect-casa-pastora":25,"proiect-casa-z247":33,"proiect-casa-paz":33,"proiect-casa-z97":25,"proiect-casa-piedad":25,"proiect-casa-z284-gp2":31,"proiect-casa-severa-2":31,"proiect-casa-zx45":65,"proiect-casa-pilar":65,"proiect-casa-z158":99,"proiect-casa-belinda-2":99,"proiect-casa-z8-d-40":48,"proiect-casa-ursula-12":48,"proiect-casa-z230":75,"proiect-casa-marcella-2":75,"proiect-casa-z306":71,"proiect-casa-sacramento":71,"proiect-casa-z311":28,"proiect-casa-salud":28,"proiect-casa-z312":33,"proiect-casa-socorro":33,"proiect-casa-z82":32,"proiect-casa-soledad":32,"proiect-casa-zx108":91,"proiect-casa-soraya":91,"proiect-casa-zb16":31,"proiect-casa-triana":31,"proiect-casa-zx124":25,"proiect-casa-almudena":25,"proiect-casa-z84":32,"proiect-casa-ascension":32,"proiect-casa-zx123":140,"proiect-casa-asuncion":140,"proiect-casa-z156-a":26,"proiect-casa-reyes-2":26,"proiect-casa-z320":70,"proiect-casa-concha":70,"proiect-casa-zx95":110,"proiect-casa-doloritas":110,"proiect-casa-zx127":57,"proiect-casa-eulalita":57,"proiect-casa-zx128":80,"proiect-casa-leyre":80,"proiect-casa-z9":29,"proiect-casa-valvanera":29,"proiect-casa-z331":78,"proiect-casa-zulema":78,"proiect-casa-z341":112,"proiect-casa-aimee":112,"proiect-casa-zx132":28,"proiect-casa-alix":28,"proiect-casa-z351":41,"proiect-casa-giovanna-2":41,"proiect-casa-zx22":105,"proiect-casa-anais":105,"proiect-casa-zx72":140,"proiect-casa-angelique":140};

  /* ── PRODUCT DATA CACHE ────────────────────────────────────────────────── */
  var ALL_PRODUCTS = [];
  var SEEN_CARD_IDS = {};

  /* ── INIT ──────────────────────────────────────────────────────────────── */
  function init() {
    var cards = document.querySelectorAll("[data-sb-product]");
    ALL_PRODUCTS = [];
    SEEN_CARD_IDS = {};

    /* Filter out deposit product from DOM immediately and deduplicate */
    cards.forEach(function(card) {
      var t = (card.dataset.title || "").toLowerCase();
      var id = card.dataset.productId || card.dataset.handle;
      if (t.indexOf("avans rezervare") !== -1 || id === "16246197092677" || (id && SEEN_CARD_IDS[id])) {
        card.style.display = "none";
        card.remove();
      } else if (id) {
        SEEN_CARD_IDS[id] = true;
      }
    });

    var meta = document.getElementById("z-sb-meta");
    var colUrl = meta ? (meta.dataset.collectionUrl || window.location.pathname) : window.location.pathname;
    var storageKey = "arhi_cards_cache_v2_" + colUrl.replace(/[^a-zA-Z0-9_-]/g, "_");
    var grid = document.getElementById("z-products-grid");

    // Inserare carduri din cache inainte de parsare, eliminand complet dublul render pe refresh
    try {
      var cachedExtraHtml = sessionStorage.getItem(storageKey);
      if (cachedExtraHtml && grid) {
        var tempDiv = document.createElement("div");
        tempDiv.innerHTML = cachedExtraHtml;
        var frag = document.createDocumentFragment();
        while (tempDiv.firstChild) {
          var cardNode = tempDiv.firstChild;
          if (cardNode.nodeType === 1 && cardNode.hasAttribute && cardNode.hasAttribute("data-sb-product")) {
            var cid = cardNode.getAttribute("data-product-id") || cardNode.getAttribute("data-handle");
            if (cid && !SEEN_CARD_IDS[cid]) {
              SEEN_CARD_IDS[cid] = true;
              cardNode.style.display = "none";
              frag.appendChild(cardNode);
            } else {
              tempDiv.removeChild(cardNode);
            }
          } else {
            tempDiv.removeChild(cardNode);
          }
        }
        grid.appendChild(frag);
      }
    } catch (e) {
      console.warn("[z500-sidebar] Citire cache sesiune esuata:", e);
    }

    cards = document.querySelectorAll("[data-sb-product]");
    /* Build unique name map FIRST (alphabetically sorted) */
    buildNameMap(cards);
    cards.forEach(function(card, idx) {
      var parsed = parseCardData(card, idx);
      ALL_PRODUCTS.push(parsed);
      applyHouseNameToCard(card, parsed.displayName, parsed.originalTitle);
    });

    bindRangeSliders();
    bindChips();
    bindSearch();
    bindSort();
    bindMobileToggle();
    bindSectionToggles();
    bindPresets();
    bindQuickFilters();
    bindGridDensity();
    renderActiveFilters();
    applyFilters();
    document.documentElement.classList.add("z-sidebar-ready");
    loadMorePagesIfNeeded();
  }

  /* Afișează STRICT titlul oficial din Shopify – fără nume artificiale duble și fără tag Model redundant */
  function applyHouseNameToCard(card, displayName, originalTitle) {
    var titleEl = card.querySelector(".z-prod-title");
    if (!titleEl) return;
    titleEl.innerHTML = '<span class="z-prod-name-display">' + originalTitle + '</span>';
  }

  /* ── PARSE CARD DATA ───────────────────────────────────────────────────── */
  function parseCardData(card, idx) {
    var originalTitle = (card.dataset.title || "");
    var handle = (card.dataset.handle || "");
    if (!handle) {
      var a = card.querySelector("a.z-prod-img-wrap") || card.querySelector("a");
      var href = a ? (a.getAttribute("href") || "") : "";
      var match = href.match(/\/products\/([^\/?#]+)/);
      handle = match ? match[1] : "";
    }
    var curationScore = (typeof FEATURED_SCORES !== "undefined" && FEATURED_SCORES[handle]) ? FEATURED_SCORES[handle] : 0;

    return {
      el:            card,
      originalIndex: idx,
      handle:        handle,
      curationScore: curationScore,
      originalTitle: originalTitle,
      displayName:   getHouseName(originalTitle),
      title:         originalTitle.toLowerCase(),
      subtitle:      (card.dataset.subtitle || "").toLowerCase(),
      usable:        parseFloat(card.dataset.usable || 0),
      built:         parseFloat(card.dataset.built || 0),
      rooms:         parseInt(card.dataset.rooms || 0),
      floors:        (card.dataset.floors || "").toLowerCase(),
      garage:        (card.dataset.garage || "").toLowerCase(),
      roof:          (card.dataset.roof || "").toLowerCase(),
      tags:          (card.dataset.tags || "").toLowerCase(),
      price:         parseFloat(card.dataset.price || 0)
    };
  }

  /* ── RANGE SLIDERS ─────────────────────────────────────────────────────── */
  function bindRangeSliders() {
    bindDualRange("usable", 0, 600, function(min, max) {
      STATE.usableMin = min;
      STATE.usableMax = max;
      STATE.page = 1;
      syncPresetsToRange("usable", min, max);
      renderActiveFilters();
      applyFilters();
    });
    bindDualRange("built", 30, 400, function(min, max) {
      STATE.builtMin = min;
      STATE.builtMax = max;
      STATE.page = 1;
      renderActiveFilters();
      applyFilters();
    });
  }

  function bindDualRange(key, globalMin, globalMax, onChange) {
    var minInput = document.getElementById("sb-range-" + key + "-min");
    var maxInput = document.getElementById("sb-range-" + key + "-max");
    var fill     = document.getElementById("sb-range-" + key + "-fill");
    var valMin   = document.getElementById("sb-range-" + key + "-valmin");
    var valMax   = document.getElementById("sb-range-" + key + "-valmax");
    if (!minInput || !maxInput) return;

    function update() {
      var lo = parseFloat(minInput.value);
      var hi = parseFloat(maxInput.value);
      if (lo > hi - 5) {
        lo = hi - 5;
        minInput.value = lo;
      }
      var pctLo = ((lo - globalMin) / (globalMax - globalMin)) * 100;
      var pctHi = ((hi - globalMin) / (globalMax - globalMin)) * 100;
      if (fill) {
        fill.style.left  = pctLo + "%";
        fill.style.width = (pctHi - pctLo) + "%";
      }
      if (valMin) valMin.textContent = Math.round(lo) + " m²";
      if (valMax) valMax.textContent = Math.round(hi) + " m²";
      onChange(lo, hi);
    }

    minInput.addEventListener("input", update);
    maxInput.addEventListener("input", update);
    update();
  }

  /* ── PRESETS ───────────────────────────────────────────────────────────── */
  function bindPresets() {
    var presets = document.querySelectorAll("[data-sb-preset]");
    presets.forEach(function(btn) {
      btn.addEventListener("click", function(e) {
        e.preventDefault();
        var min = parseFloat(btn.dataset.min);
        var max = parseFloat(btn.dataset.max);
        var key = btn.dataset.sbPreset;

        var siblings = document.querySelectorAll("[data-sb-preset='" + key + "']");
        siblings.forEach(function(s){ s.classList.remove("active"); });
        btn.classList.add("active");

        var minInput = document.getElementById("sb-range-" + key + "-min");
        var maxInput = document.getElementById("sb-range-" + key + "-max");
        if (minInput) { minInput.value = min; minInput.dispatchEvent(new Event("input")); }
        if (maxInput) { maxInput.value = max; maxInput.dispatchEvent(new Event("input")); }
      });
    });
  }

  function syncPresetsToRange(key, min, max) {
    var presets = document.querySelectorAll("[data-sb-preset='" + key + "']");
    presets.forEach(function(btn) {
      var pMin = parseFloat(btn.dataset.min);
      var pMax = parseFloat(btn.dataset.max);
      btn.classList.toggle("active", Math.abs(pMin - min) < 1 && Math.abs(pMax - max) < 1);
    });
  }

  /* ── CHIPS (FILTRE RAPIDE BUTOANE) ─────────────────────────────────────── */
  function bindChips() {
    var chips = document.querySelectorAll("[data-sb-chip]");
    chips.forEach(function(chip) {
      chip.addEventListener("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        var key = chip.dataset.sbChip;
        var val = chip.dataset.value;
        if (!key || !val || !STATE[key]) return;

        STATE.page = 1;
        var arr = STATE[key];
        var idx = arr.indexOf(val);
        if (idx === -1) {
          arr.push(val);
          chip.classList.add("selected");
          chip.setAttribute("aria-checked", "true");
        } else {
          arr.splice(idx, 1);
          chip.classList.remove("selected");
          chip.setAttribute("aria-checked", "false");
        }

        updateChipCount(key);
        renderActiveFilters();
        applyFilters();
      });
    });
  }

  function updateChipCount(key) {
    var el = document.querySelector("[data-sb-count='" + key + "']");
    if (!el) return;
    var count = STATE[key].length;
    el.textContent = count;
    el.style.display = count ? "" : "none";
  }

  /* ── SEARCH ────────────────────────────────────────────────────────────── */
  function bindSearch() {
    var input = document.getElementById("sb-search-input");
    if (!input) return;
    var debounceTimer;
    input.addEventListener("input", function() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() {
        STATE.search = input.value.trim().toLowerCase();
        STATE.page = 1;
        renderActiveFilters();
        applyFilters();
      }, 200);
    });
  }

  /* ── SORT (BUTOANE + SELECT) ───────────────────────────────────────────── */
  function bindSort() {
    var sel = document.getElementById("sb-sort-select");
    var btns = document.querySelectorAll(".z-sort-btn");

    function setSort(val) {
      STATE.sort = val;
      STATE.page = 1;
      if (sel && sel.value !== val) {
        sel.value = val;
      }
      btns.forEach(function(b) {
        b.classList.toggle("active", b.dataset.sort === val);
      });
      applyFilters();
    }

    if (sel) {
      sel.addEventListener("change", function() {
        setSort(sel.value);
      });
    }

    btns.forEach(function(btn) {
      btn.addEventListener("click", function(e) {
        e.preventDefault();
        var sortVal = btn.dataset.sort;
        if (sortVal) setSort(sortVal);
      });
    });
  }

  /* ── MOBILE TOGGLE ─────────────────────────────────────────────────────── */
  function bindMobileToggle() {
    var btn = document.getElementById("sb-mobile-toggle");
    var sidebar = document.getElementById("z-sidebar-panel");
    if (!btn || !sidebar) return;
    btn.addEventListener("click", function() {
      sidebar.classList.toggle("sb-open");
    });
  }

  /* ── ACCORDION SECTIONS ────────────────────────────────────────────────── */
  function bindSectionToggles() {
    var heads = document.querySelectorAll(".z-sb-section-head");
    heads.forEach(function(head) {
      head.addEventListener("click", function() {
        var section = head.closest(".z-sb-section");
        if (section) section.classList.toggle("is-open");
      });
    });
  }

  /* ── QUICK FILTER CHIPS (1-CLICK ARCHITECTURAL SHORTCUTS) ─────────────── */
  function bindQuickFilters() {
    var quickChips = document.querySelectorAll(".z-quick-chip");
    quickChips.forEach(function(chip) {
      chip.addEventListener("click", function(e) {
        e.preventDefault();
        var quickType = chip.dataset.quick;

        if (quickType === "all") {
          resetAll();
          return;
        }

        if (quickType === "parter") {
          resetAllWithoutRender();
          STATE.floors = ["casa parter"];
          selectSidebarChip("floors", "casa parter");
        } else if (quickType === "mansarda") {
          resetAllWithoutRender();
          STATE.floors = ["casa cu mansarda"];
          selectSidebarChip("floors", "casa cu mansarda");
        } else if (quickType === "vila") {
          resetAllWithoutRender();
          STATE.styles = ["vila moderna"];
          selectSidebarChip("styles", "vila moderna");
        } else if (quickType === "sub140") {
          resetAllWithoutRender();
          STATE.usableMin = 0;
          STATE.usableMax = 140;
          syncDualRangeInputs("usable", 0, 140);
        } else if (quickType === "garaj2") {
          resetAllWithoutRender();
          STATE.garage = ["garaj dublu"];
          selectSidebarChip("garage", "garaj dublu");
        }

        STATE.page = 1;
        renderActiveFilters();
        applyFilters();
      });
    });
  }

  function selectSidebarChip(groupKey, val) {
    var chip = document.querySelector("[data-sb-chip='" + groupKey + "'][data-value='" + val + "']");
    if (chip) {
      chip.classList.add("selected");
      chip.setAttribute("aria-checked", "true");
      updateChipCount(groupKey);
    }
  }

  function syncDualRangeInputs(key, min, max) {
    var minInput = document.getElementById("sb-range-" + key + "-min");
    var maxInput = document.getElementById("sb-range-" + key + "-max");
    if (minInput) minInput.value = min;
    if (maxInput) {
      maxInput.value = max;
      maxInput.dispatchEvent(new Event("input"));
    }
  }

  function resetAllWithoutRender() {
    STATE.search = "";
    STATE.usableMin = 0; STATE.usableMax = 600;
    STATE.builtMin = 30; STATE.builtMax = 400;
    STATE.floors = []; STATE.garage = []; STATE.rooms = [];
    STATE.styles = []; STATE.roofType = [];

    var inp = document.getElementById("sb-search-input");
    if (inp) inp.value = "";
    resetRange("usable", 0, 600);
    resetRange("built", 30, 400);
    document.querySelectorAll("[data-sb-chip]").forEach(function(c){
      c.classList.remove("selected");
      c.setAttribute("aria-checked", "false");
    });
    ["floors","garage","rooms","styles","roofType"].forEach(function(k){ updateChipCount(k); });
  }

  function updateQuickChipsHighlight() {
    var activeCount = getActiveFilterCount();
    var allChip = document.querySelector(".z-quick-chip[data-quick='all']");
    var parterChip = document.querySelector(".z-quick-chip[data-quick='parter']");
    var mansardaChip = document.querySelector(".z-quick-chip[data-quick='mansarda']");
    var vilaChip = document.querySelector(".z-quick-chip[data-quick='vila']");
    var sub140Chip = document.querySelector(".z-quick-chip[data-quick='sub140']");
    var garaj2Chip = document.querySelector(".z-quick-chip[data-quick='garaj2']");

    document.querySelectorAll(".z-quick-chip").forEach(function(c) {
      c.classList.remove("is-active");
    });

    if (activeCount === 0) {
      if (allChip) allChip.classList.add("is-active");
      return;
    }

    if (STATE.floors.length === 1 && STATE.floors[0] === "casa parter" && activeCount === 1) {
      if (parterChip) parterChip.classList.add("is-active");
    } else if (STATE.floors.length === 1 && STATE.floors[0] === "casa cu mansarda" && activeCount === 1) {
      if (mansardaChip) mansardaChip.classList.add("is-active");
    } else if (STATE.styles.length === 1 && STATE.styles[0] === "vila moderna" && activeCount === 1) {
      if (vilaChip) vilaChip.classList.add("is-active");
    } else if (STATE.usableMin === 0 && STATE.usableMax === 140 && activeCount === 1) {
      if (sub140Chip) sub140Chip.classList.add("is-active");
    } else if (STATE.garage.length === 1 && STATE.garage[0] === "garaj dublu" && activeCount === 1) {
      if (garaj2Chip) garaj2Chip.classList.add("is-active");
    }
  }

  /* ── GRID DENSITY TOGGLE (3-COL VS 2-COL DETAILED) ─────────────────────── */
  function bindGridDensity() {
    var btn3Col = document.getElementById("zDensity3Col");
    var btn2Col = document.getElementById("zDensity2Col");
    var grid = document.getElementById("z-products-grid");
    if (!btn3Col || !btn2Col || !grid) return;

    // Restore density preference
    try {
      var savedDensity = localStorage.getItem("arhi_catalog_density");
      if (savedDensity === "2col") {
        grid.classList.add("z-grid-2col");
        btn2Col.classList.add("is-active");
        btn2Col.setAttribute("aria-pressed", "true");
        btn3Col.classList.remove("is-active");
        btn3Col.setAttribute("aria-pressed", "false");
      }
    } catch(e) {}

    btn3Col.addEventListener("click", function() {
      grid.classList.remove("z-grid-2col");
      btn3Col.classList.add("is-active");
      btn3Col.setAttribute("aria-pressed", "true");
      btn2Col.classList.remove("is-active");
      btn2Col.setAttribute("aria-pressed", "false");
      try { localStorage.setItem("arhi_catalog_density", "3col"); } catch(e){}
    });

    btn2Col.addEventListener("click", function() {
      grid.classList.add("z-grid-2col");
      btn2Col.classList.add("is-active");
      btn2Col.setAttribute("aria-pressed", "true");
      btn3Col.classList.remove("is-active");
      btn3Col.setAttribute("aria-pressed", "false");
      try { localStorage.setItem("arhi_catalog_density", "2col"); } catch(e){}
    });
  }

  /* ── APPLY FILTERS & SORTARE & PAGINARE ─────────────────────────────────── */
  function applyFilters() {
    var sort = STATE.sort || (document.getElementById("sb-sort-select") || {}).value || "default";

    var matched = ALL_PRODUCTS.filter(function(p) {
      // 1. Cautare text (in titlu, subtitlu si taguri)
      if (STATE.search) {
        var hay = p.title + " " + p.subtitle + " " + p.tags + " " + (p.displayName || "").toLowerCase();
        if (!hay.includes(STATE.search)) return false;
      }
      // 2. Suprafata utila (din metafield numeric)
      if (p.usable > 0) {
        if (p.usable < STATE.usableMin || p.usable > STATE.usableMax) return false;
      }
      // 3. Suprafata construita (din metafield numeric)
      if (p.built > 0) {
        if (p.built < STATE.builtMin || p.built > STATE.builtMax) return false;
      }
      // 4. Regim inaltime / etaje
      if (STATE.floors.length > 0) {
        var matchesFloor = STATE.floors.some(function(f) {
          if (p.floors) {
            return p.floors.includes(f);
          }
          // Fallback pe taguri daca nu exista p.floors
          return p.tags.includes(f);
        });
        if (!matchesFloor) return false;
      }

      // 5. Garaj
      if (STATE.garage.length > 0) {
        var matchesGarage = STATE.garage.some(function(g) {
          if (p.garage) {
            return p.garage === g;
          }
          // Fallback
          return p.tags.includes(g);
        });
        if (!matchesGarage) return false;
      }

      // 6. Numar camere (foloseste p.rooms curat din card sau tag)
      if (STATE.rooms.length > 0) {
        var rNum = p.rooms;
        var hasRoom = STATE.rooms.some(function(r) {
          if (r === "6+") {
            return rNum >= 6 || p.tags.includes("6 camere") || p.tags.includes("7 camere") || p.tags.includes("8 camere");
          }
          var target = parseInt(r, 10);
          return rNum === target || p.tags.includes(r + " camere");
        });
        if (!hasRoom) return false;
      }

      // 7. Stil arhitectural (tag + titlu + subtitlu cu alias-uri inteligente)
      if (STATE.styles.length > 0) {
        var STYLE_ALIASES = {
          "stil industrial":    ["stil industrial", "industrial", "industriala", "industrială", "loft", "cubist", "kubist", "zx"],
          "stil rustic":        ["stil rustic", "rustic", "rustica", "rustică", "lemn", "bustean", "buștean", "brzechwa"],
          "stil modern":        ["stil modern", "modern", "moderna", "modernă", "contemporan"],
          "stil traditional":   ["stil traditional", "traditional", "tradițional", "traditionala", "tradițională"],
          "stil scandinav":     ["stil scandinav", "scandinav", "scandinava", "nordic"],
          "stil mediteranean":  ["stil mediteranean", "mediteran", "mediteranean", "mediteraneana", "toscan"],
          "stil italian":       ["stil italian", "italian", "italiana"],
          "stil hambar":        ["stil hambar", "hambar", "barn", "barnhouse"],
          "stil clasic":        ["stil clasic", "clasic", "clasica", "clasică"],
          "stil minimalist":    ["stil minimalist", "minimalist", "minimalista", "minimalistă"],
          "vila moderna":       ["vila moderna", "vilă modernă", "vila", "vilă", "rezidenta", "reședință", "lux"]
        };

        var sHay = (p.tags + " " + p.title + " " + p.subtitle).toLowerCase();
        var matchesStyle = STATE.styles.some(function(selectedStyle) {
          var aliases = STYLE_ALIASES[selectedStyle] || [selectedStyle];
          return aliases.some(function(alias) {
            return sHay.includes(alias);
          });
        });

        if (!matchesStyle) return false;
      }

      // 8. Tip acoperis
      if (STATE.roofType.length > 0) {
        var matchesRoof = STATE.roofType.some(function(selectedRoof) {
          if (p.roof) {
            return p.roof === selectedRoof;
          }
          // Fallback
          return p.tags.includes(selectedRoof);
        });
        if (!matchesRoof) return false;
      }
      return true;
    });

    // Sortare array
    // Sortare array peste TOATE produsele gasite (nu doar cele 30 vizibile)
    matched.sort(function(a, b) {
      if (sort === "price-asc")   return a.price - b.price;
      if (sort === "price-desc")  return b.price - a.price;
      if (sort === "area-asc")    return a.usable - b.usable;
      if (sort === "area-desc")   return b.usable - a.usable;
      if (sort === "title-asc")   return a.title.localeCompare(b.title);
      // Default "Recomandate": afiseaza in fata modelele cu cel mai mare scor de design & popularitate
      if (b.curationScore !== a.curationScore) {
        return b.curationScore - a.curationScore;
      }
      return a.originalIndex - b.originalIndex;
    });

    var meta = document.getElementById("z-sb-meta");
    var totalStoreCount = meta ? parseInt(meta.dataset.totalCount || "0", 10) : 0;
    var hasActiveFilters = getActiveFilterCount() > 0;

    // Numar total real: daca nu sunt filtre active si catalogul este inca in curs de sync,
    // afisam numarul total real al magazinului (ex: 900 sau 50)
    var effectiveTotal = (!hasActiveFilters && totalStoreCount > matched.length)
      ? totalStoreCount
      : matched.length;

    // Paginare pe client: exact 30 de produse pe pagina
    var totalPages = Math.ceil(effectiveTotal / STATE.perPage) || 1;
    if (STATE.page > totalPages) {
      STATE.page = 1;
    }
    var startIdx = (STATE.page - 1) * STATE.perPage;
    var pageItems = matched.slice(startIdx, startIdx + STATE.perPage);

    // Reordonare si afisare/ascundere in DOM: doar cele 30 de produse ale paginii curente sunt vizibile
    var grid = document.getElementById("z-products-grid");
    ALL_PRODUCTS.forEach(function(p) {
      p.el.style.display = "none";
    });

    if (grid) {
      pageItems.forEach(function(p) {
        p.el.style.display = "";
        grid.appendChild(p.el);
      });

      var emptyEl = document.getElementById("sb-no-results");
      if (emptyEl) {
        grid.appendChild(emptyEl);
      }
    }
    document.documentElement.classList.add("z-sidebar-ready");

    // Numar total rezultate - afiseaza MEREU numarul real total al colectiei/filtrarii
    var countEl = document.getElementById("sb-results-count");
    if (countEl) {
      var countText = "";
      if (effectiveTotal > STATE.perPage) {
        var endIdx = Math.min(startIdx + STATE.perPage, effectiveTotal);
        countText = "Afișare <strong>" + (startIdx + 1) + "–" + endIdx + "</strong> din <strong>" + effectiveTotal + "</strong> proiecte";
      } else {
        countText = "<strong>" + effectiveTotal + "</strong> proiect" + (effectiveTotal !== 1 ? "e" : "") + " disponibile";
      }
      countEl.innerHTML = '<span class="z-counter-indicator" aria-hidden="true"></span><span class="z-counter-text">' + countText + '</span>';
    }

    // Stare goala
    var emptyEl = document.getElementById("sb-no-results");
    if (emptyEl) {
      emptyEl.style.display = (matched.length === 0 && ALL_PRODUCTS.length > 0) ? "" : "none";
    }

    // Randare butoane de paginare dinamica (30 pe pagina)
    renderPagination(totalPages, effectiveTotal);

    // Actualizare chip-uri rapide (Quick filter highlight)
    updateQuickChipsHighlight();

    // Mobile badge
    var badge = document.querySelector(".sb-badge-count");
    if (badge) badge.textContent = getActiveFilterCount() || "";
  }

  function getActiveFilterCount() {
    var n = 0;
    if (STATE.search) n++;
    if (STATE.usableMin > 0 || STATE.usableMax < 600) n++;
    if (STATE.builtMin > 30 || STATE.builtMax < 400) n++;
    n += STATE.floors.length + STATE.garage.length + STATE.rooms.length +
         STATE.styles.length + STATE.roofType.length;
    return n;
  }

  /* ── PAGINARE DINAMICA JAVASCRIPT (30 PE PAGINA) ────────────────────────── */
  function renderPagination(totalPages, totalItems) {
    var nav = document.getElementById("sb-pagination");
    if (!nav) return;
    if (totalPages <= 1) {
      nav.innerHTML = "";
      nav.style.display = "none";
      return;
    }
    nav.style.display = "";

    var cur = STATE.page;
    var html = '<ul class="z-sb-pagination-list">';

    // Buton Inapoi
    if (cur > 1) {
      html += '<li class="z-sb-page-item"><button type="button" class="z-sb-page-link" data-page="' + (cur - 1) + '" aria-label="Pagina anterioară">← Înapoi</button></li>';
    } else {
      html += '<li class="z-sb-page-item is-disabled"><span class="z-sb-page-link">← Înapoi</span></li>';
    }

    // Butoane numerotate
    for (var p = 1; p <= totalPages; p++) {
      if (p === 1 || p === totalPages || (p >= cur - 2 && p <= cur + 2)) {
        if (p === cur) {
          html += '<li class="z-sb-page-item is-current"><span class="z-sb-page-link" aria-current="page">' + p + '</span></li>';
        } else {
          html += '<li class="z-sb-page-item"><button type="button" class="z-sb-page-link" data-page="' + p + '">' + p + '</button></li>';
        }
      } else if (p === cur - 3 || p === cur + 3) {
        html += '<li class="z-sb-page-item is-deco"><span class="z-sb-page-link">…</span></li>';
      }
    }

    // Buton Inainte
    if (cur < totalPages) {
      html += '<li class="z-sb-page-item"><button type="button" class="z-sb-page-link" data-page="' + (cur + 1) + '" aria-label="Pagina următoare">Înainte →</button></li>';
    } else {
      html += '<li class="z-sb-page-item is-disabled"><span class="z-sb-page-link">Înainte →</span></li>';
    }

    html += '</ul>';
    nav.innerHTML = html;

    // Evenimente click pe butoanele de paginare (fara reload de pagina)
    nav.querySelectorAll("button[data-page]").forEach(function(btn) {
      btn.addEventListener("click", function(e) {
        e.preventDefault();
        var targetPage = parseInt(btn.dataset.page, 10);
        if (targetPage && targetPage !== STATE.page) {
          STATE.page = targetPage;
          applyFilters();
          var topEl = document.querySelector(".z-results-panel") || document.getElementById("z-products-grid");
          if (topEl) {
            topEl.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }
      });
    });
  }

  /* ── INCARCARE ASINCRONA IN PARALEL IN FUNDAL PENTRU CATALOG MARE (> 250 PRODUSE) ── */
  var _isLoadingMore = false;
  function loadMorePagesIfNeeded() {
    if (_isLoadingMore) return;
    var meta = document.getElementById("z-sb-meta");
    if (!meta) return;
    var totalPages = parseInt(meta.dataset.totalPages || "1", 10);
    var colUrl = meta.dataset.collectionUrl || window.location.pathname;
    var currentPage = parseInt(meta.dataset.currentPage || "1", 10);

    if (totalPages <= 1) {
      document.documentElement.classList.add("z-sidebar-ready");
      return;
    }

    var storageKey = "arhi_cards_cache_v2_" + colUrl.replace(/[^a-zA-Z0-9_-]/g, "_");
    try {
      if (sessionStorage.getItem(storageKey)) {
        document.documentElement.classList.add("z-sidebar-ready");
        return;
      }
    } catch (e) {}

    _isLoadingMore = true;

    var grid = document.getElementById("z-products-grid");
    var pagesToFetch = [];
    for (var p = 1; p <= totalPages; p++) {
      if (p !== currentPage) {
        pagesToFetch.push(p);
      }
    }

    var promises = pagesToFetch.map(function(pageNumber) {
      var fetchUrl = colUrl + (colUrl.includes("?") ? "&" : "?") + "page=" + pageNumber;
      return fetch(fetchUrl)
        .then(function(res) {
          if (!res.ok) throw new Error("HTTP " + res.status);
          return res.text();
        })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var newCards = Array.from(doc.querySelectorAll("[data-sb-product]"));
          return { page: pageNumber, cards: newCards };
        })
        .catch(function(err) {
          console.warn("[z500-sidebar] Eroare incarcare pagina " + pageNumber + ":", err);
          return { page: pageNumber, cards: [] };
        });
    });

    Promise.all(promises).then(function(results) {
      results.sort(function(a, b) { return a.page - b.page; });
      var extraCardsHtml = "";
      results.forEach(function(r) {
        r.cards.forEach(function(card) {
          var t = (card.dataset.title || "").toLowerCase();
          var id = card.dataset.productId || card.dataset.handle;
          if (t.indexOf("avans rezervare") !== -1 || id === "16246197092677" || (id && SEEN_CARD_IDS[id])) {
            card.remove();
            return;
          }
          if (id) SEEN_CARD_IDS[id] = true;
          extraCardsHtml += card.outerHTML;
          card.style.display = "none";
          if (grid) grid.appendChild(card);
          var parsed = parseCardData(card, ALL_PRODUCTS.length);
          ALL_PRODUCTS.push(parsed);
          applyHouseNameToCard(card, parsed.displayName, parsed.originalTitle);
        });
      });
      // Re-index originalIndex
      ALL_PRODUCTS.forEach(function(item, idx) {
        item.originalIndex = idx;
      });
      try {
        if (extraCardsHtml) {
          sessionStorage.setItem(storageKey, extraCardsHtml);
        }
      } catch (err) {
        console.warn("[z500-sidebar] Quota exceeded sessionStorage:", err);
      }
      _isLoadingMore = false;
      document.documentElement.classList.add("z-sidebar-ready");
      applyFilters();
    });
  }

  /* ── ACTIVE FILTER PILLS ───────────────────────────────────────────────── */
  function renderActiveFilters() {
    var bar = document.getElementById("sb-active-bar");
    if (!bar) return;
    bar.innerHTML = "";
    var pills = [];

    function addPill(label, removeCallback) {
      var pill = document.createElement("span");
      pill.className = "z-sb-pill";
      pill.innerHTML = label + '<span class="sb-remove" title="Șterge">×</span>';
      pill.querySelector(".sb-remove").addEventListener("click", removeCallback);
      bar.appendChild(pill);
      pills.push(pill);
    }

    if (STATE.search) {
      addPill('🔍 "' + STATE.search + '"', function() {
        STATE.search = "";
        STATE.page = 1;
        var inp = document.getElementById("sb-search-input");
        if (inp) inp.value = "";
        renderActiveFilters(); applyFilters();
      });
    }
    if (STATE.usableMin > 0 || STATE.usableMax < 600) {
      addPill("Util: " + Math.round(STATE.usableMin) + "–" + Math.round(STATE.usableMax) + " m²", function() {
        STATE.usableMin = 0; STATE.usableMax = 600;
        STATE.page = 1;
        resetRange("usable", 0, 600);
        renderActiveFilters(); applyFilters();
      });
    }
    if (STATE.builtMin > 30 || STATE.builtMax < 400) {
      addPill("Construită: " + Math.round(STATE.builtMin) + "–" + Math.round(STATE.builtMax) + " m²", function() {
        STATE.builtMin = 30; STATE.builtMax = 400;
        STATE.page = 1;
        resetRange("built", 30, 400);
        renderActiveFilters(); applyFilters();
      });
    }

    function addArrayPills(arr, key, labelFn) {
      arr.slice().forEach(function(val) {
        addPill(labelFn(val), function() {
          var idx = STATE[key].indexOf(val);
          if (idx > -1) { STATE[key].splice(idx, 1); }
          STATE.page = 1;
          var chip = document.querySelector("[data-sb-chip='" + key + "'][data-value='" + val + "']");
          if (chip) {
            chip.classList.remove("selected");
            chip.setAttribute("aria-checked", "false");
          }
          updateChipCount(key);
          renderActiveFilters(); applyFilters();
        });
      });
    }
    addArrayPills(STATE.floors,   "floors",   function(v){ return "Etaje: " + (FLOORS_MAP[v] || v); });
    addArrayPills(STATE.garage,   "garage",   function(v){ return "Garaj: " + (GARAGE_MAP[v] || v); });
    addArrayPills(STATE.rooms,    "rooms",    function(v){ return "Camere: " + v; });
    addArrayPills(STATE.styles,   "styles",   function(v){ return "Stil: " + (STYLES_MAP[v] || v); });
    addArrayPills(STATE.roofType, "roofType", function(v){ return "Acoperiș: " + (ROOF_MAP[v] || v); });

    bar.classList.toggle("has-filters", pills.length > 0);
  }

  function resetRange(key, min, max) {
    var minInput = document.getElementById("sb-range-" + key + "-min");
    var maxInput = document.getElementById("sb-range-" + key + "-max");
    if (minInput) { minInput.value = min; minInput.dispatchEvent(new Event("input")); }
    if (maxInput) { maxInput.value = max; maxInput.dispatchEvent(new Event("input")); }
    var presets = document.querySelectorAll("[data-sb-preset='" + key + "']");
    presets.forEach(function(b){ b.classList.remove("active"); });
  }

  /* ── RESET ALL ─────────────────────────────────────────────────────────── */
  function resetAll() {
    STATE.search = "";
    STATE.sort = "default";
    STATE.page = 1;
    STATE.usableMin = 0; STATE.usableMax = 600;
    STATE.builtMin = 30; STATE.builtMax = 400;
    STATE.floors = []; STATE.garage = []; STATE.rooms = [];
    STATE.styles = []; STATE.roofType = [];

    var inp = document.getElementById("sb-search-input");
    if (inp) inp.value = "";
    var sel = document.getElementById("sb-sort-select");
    if (sel) sel.value = "default";
    var btns = document.querySelectorAll(".z-sort-btn");
    btns.forEach(function(b) {
      b.classList.toggle("active", b.dataset.sort === "default");
    });

    resetRange("usable", 0, 600);
    resetRange("built", 30, 400);
    document.querySelectorAll("[data-sb-chip]").forEach(function(c){
      c.classList.remove("selected");
      c.setAttribute("aria-checked", "false");
    });
    ["floors","garage","rooms","styles","roofType"].forEach(function(k){ updateChipCount(k); });
    renderActiveFilters();
    applyFilters();
  }

  /* ── INITIALIZATION ────────────────────────────────────────────────────── */
  function start() {
    var resetBtn = document.getElementById("sb-reset-btn");
    if (resetBtn) resetBtn.addEventListener("click", resetAll);
    var emptyResetBtn = document.getElementById("sb-empty-reset");
    if (emptyResetBtn) emptyResetBtn.addEventListener("click", resetAll);
    init();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  document.addEventListener("shopify:section:load", function() {
    start();
  });

  window.zSidebarReset = resetAll;
})();
